import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import GerenciamentoDepartamentos from '../departamento/GerenciamentoDepartamentos';
import AlterarSenhaModal from './AlterarSenhaModal';
import { toast } from 'react-toastify';

const Settings: React.FC = () => {
  const { usuario } = useAuth();
  const [configuracoes, setConfiguracoes] = useState({
    tema: 'claro',
    idioma: 'pt-BR',
    notificacoesEmail: true,
    notificacoesSistema: true,
    notificacoesSom: false
  });
  
  // Estado para controlar a exibição do modal de alteração de senha
  const [modalSenhaAberto, setModalSenhaAberto] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target as HTMLInputElement;
    
    setConfiguracoes(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Em um cenário real, aqui seria feita uma chamada à API para salvar as configurações
    toast.success('Configurações salvas com sucesso!');
  };

  if (!usuario) {
    return <div>Carregando...</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Configurações</h1>
      
      {/* Gerenciamento de Departamentos (visível apenas para administradores) */}
      {usuario.tipo === 'admin' && (
        <div className="mb-8">
          <GerenciamentoDepartamentos />
        </div>
      )}
      
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <form onSubmit={handleSubmit}>
          <div className="p-6">
            <h2 className="text-lg font-semibold mb-4">Notificações</h2>
            
            <div className="space-y-4">
              <div className="flex items-center">
                <input
                  id="notificacoes-email"
                  name="notificacoesEmail"
                  type="checkbox"
                  checked={configuracoes.notificacoesEmail}
                  onChange={handleChange}
                  className="h-4 w-4 text-bravo-primary focus:ring-bravo-primary border-gray-300 rounded"
                />
                <label htmlFor="notificacoes-email" className="ml-2 block text-sm text-gray-900">
                  Receber notificações por email
                </label>
              </div>
              
              <div className="flex items-center">
                <input
                  id="notificacoes-sistema"
                  name="notificacoesSistema"
                  type="checkbox"
                  checked={configuracoes.notificacoesSistema}
                  onChange={handleChange}
                  className="h-4 w-4 text-bravo-primary focus:ring-bravo-primary border-gray-300 rounded"
                />
                <label htmlFor="notificacoes-sistema" className="ml-2 block text-sm text-gray-900">
                  Receber notificações do sistema
                </label>
              </div>
              
              <div className="flex items-center">
                <input
                  id="notificacoes-som"
                  name="notificacoesSom"
                  type="checkbox"
                  checked={configuracoes.notificacoesSom}
                  onChange={handleChange}
                  className="h-4 w-4 text-bravo-primary focus:ring-bravo-primary border-gray-300 rounded"
                />
                <label htmlFor="notificacoes-som" className="ml-2 block text-sm text-gray-900">
                  Ativar sons de notificação
                </label>
              </div>
            </div>
            
            <hr className="my-6" />
            
            <h2 className="text-lg font-semibold mb-4">Segurança</h2>
            
            <div className="space-y-4">
              <button
                type="button"
                className="px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-100"
                onClick={() => setModalSenhaAberto(true)}
              >
                Alterar Senha
              </button>
            </div>
          </div>
          
          <div className="px-6 py-4 bg-gray-50 text-right">
            <button
              type="submit"
              className="px-4 py-2 bg-bravo-primary text-white rounded hover:bg-blue-600"
            >
              Salvar Configurações
            </button>
          </div>
        </form>
      </div>
      
      {/* Modal de alteração de senha */}
      <AlterarSenhaModal 
        isOpen={modalSenhaAberto} 
        onClose={() => setModalSenhaAberto(false)} 
      />
    </div>
  );
};

export default Settings;
